export const isSearchRequestDone = (status: string[]) =>
  status.every((st) => ['pending', 'performing'].indexOf(st) === -1);
